// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "FKGroteskNeue-Bold";
  src: local("FKGroteskNeue-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}
@font-face {
  font-family: "FKGroteskNeue-Medium";
  src: local("FKGroteskNeue-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "FKGroteskNeue-Regular";
  src: local("FKGroteskNeue-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
* {
  font-family: "FKGroteskNeue-Regular", serif;
}

.safari {
  font-synthesis-weight: none !important;
}

.react-tiny-popover-container .popup-info {
  max-width: 400px;
  background-color: #848b94;
  padding: 10px;
  border-radius: 10px;
  color: white;
}

._loading_overlay_overlay {
  position: fixed !important;
}

.general-section {
  width: 100%;
  max-width: 968px;
  margin: 5% auto;
  padding: 0 20px;
}

@media screen and (min-width: 451px) and (max-width: 800px) {
  #root {
    overflow-x: hidden;
  }
  .page-width {
    width: 100% !important;
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .general-section ul {
    padding: 10px;
  }
  .general-section p {
    margin: 0;
  }
}
@media screen and (max-width: 451px) {
  .general-section ul {
    padding: 0;
    list-style-type: none;
  }
  .general-section ul li {
    list-style-position: inside;
  }
  .general-section p {
    margin: 0 !important;
  }
  .general-section table {
    margin: 20px 0 !important;
  }
  .page-width {
    width: 100% !important;
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
  }
}
._loading_overlay_overlay {
  position: fixed !important;
}

.pointer-cursor {
  cursor: pointer;
}

.date-time-custom-header select {
  margin-right: 10px;
}

.text-align-center {
  text-align: center;
}

.color-white {
  color: #fff;
}

.color-grey7 {
  color: #9ca2a9;
}

.page-width {
  width: 968px;
  margin: auto;
}

.modal-heading {
  width: 95%;
}`, "",{"version":3,"sources":["webpack://./src/styles/root.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iCCiBU;EDhBV,wFAAA;AADF;AAMA;EACE,mCCSY;EDRZ,0FAAA;AAJF;AASA;EACE,oCCCa;EDAb,2FAAA;AAPF;AAqBA;EACE;IACE,UAAA;EAXF;EAaA;IACE,UAAA;EAXF;AACF;AAuBA;EACE;IACE,UAAA;EAbF;EAeA;IACE,UAAA;EAbF;AACF;AAgBA;EACE,2CAAA;AAdF;;AAgBA;EACE,sCAAA;AAbF;;AAgBE;EACE,gBAAA;EACA,yBCzDI;ED0DJ,aAAA;EACA,mBAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,0BAAA;AAdF;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAdF;;AAiBA;EACE;IACE,kBAAA;EAdF;EAgBA;IACE,sBAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAdF;EAiBE;IACE,aAAA;EAfJ;EAiBE;IACE,SAAA;EAfJ;AACF;AAmBA;EAEI;IACE,UAAA;IACA,qBAAA;EAlBJ;EAmBI;IACE,2BAAA;EAjBN;EAoBE;IACE,oBAAA;EAlBJ;EAoBE;IACE,yBAAA;EAlBJ;EAqBA;IACE,sBAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAnBF;AACF;AAsBA;EACE,0BAAA;AApBF;;AAuBA;EACE,eAAA;AApBF;;AAwBE;EACE,kBAAA;AArBJ;;AAyBA;EACE,kBAAA;AAtBF;;AAyBA;EACE,WClJM;AD4HR;;AAyBA;EACE,cC1IM;ADoHR;;AAyBA;EACE,YC7JW;ED8JX,YAAA;AAtBF;;AAyBA;EACE,UAAA;AAtBF","sourcesContent":["@import \"variables\";\n\n@font-face {\n  font-family: $font-bold;\n  src: local($font-bold),\n    url(../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Bold.woff)\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: $font-medium;\n  src: local($font-medium),\n    url(../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Medium.woff)\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: $font-regular;\n  src: local($font-regular),\n    url(../assets/font/FKGroteskNeue-1.1.1/woff-static/FKGroteskNeue-Regular.woff)\n      format(\"woff\");\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n* {\n  font-family: $font-regular, serif;\n}\n.safari {\n  font-synthesis-weight: none !important;\n}\n.react-tiny-popover-container {\n  .popup-info {\n    max-width: 400px;\n    background-color: $grey3;\n    padding: 10px;\n    border-radius: 10px;\n    color: white;\n  }\n}\n\n._loading_overlay_overlay {\n  position: fixed !important;\n}\n\n.general-section {\n  width: 100%;\n  max-width: 968px;\n  margin: 5% auto;\n  padding: 0 20px;\n}\n\n@media screen and ($tablet-media-min) and ($tablet-media) {\n  #root {\n    overflow-x: hidden;\n  }\n  .page-width {\n    width: 100% !important;\n    margin: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .general-section {\n    ul {\n      padding: 10px;\n    }\n    p {\n      margin: 0;\n    }\n  }\n}\n\n@media screen and ($mobile-media) {\n  .general-section {\n    ul {\n      padding: 0;\n      list-style-type: none;\n      li {\n        list-style-position: inside;\n      }\n    }\n    p {\n      margin: 0 !important;\n    }\n    table {\n      margin: 20px 0 !important;\n    }\n  }\n  .page-width {\n    width: 100% !important;\n    margin: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n._loading_overlay_overlay {\n  position: fixed !important;\n}\n\n.pointer-cursor {\n  cursor: pointer;\n}\n\n.date-time-custom-header {\n  select {\n    margin-right: 10px;\n  }\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.color-white {\n  color: $white;\n}\n\n.color-grey7 {\n  color: $grey7;\n}\n\n.page-width {\n  width: $page-width;\n  margin: auto;\n}\n\n.modal-heading {\n  width: 95%;\n}\n","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
